export const BUILD_INCLUDES = [
  "Custom design for your brand",
  "Mobile-first, responsive build",
  "Contact form and click-to-call",
  "Basic on-page SEO setup",
  "Design approval before build",
  "Private preview link before launch",
];

export const HOSTING_INCLUDES = [
  "Secure hosting with SSL",
  "Software and security updates",
  "Regular backups",
  "Uptime monitoring",
  "Small content edits on request",
  "Month-to-month — cancel anytime",
];

export const COMPARISON: { feature: string; build: boolean; hosting: boolean }[] = [
  { feature: "Custom design & page layouts", build: true, hosting: false },
  { feature: "Mobile-first responsive build", build: true, hosting: false },
  { feature: "Contact form & click-to-call", build: true, hosting: false },
  { feature: "Basic on-page SEO setup", build: true, hosting: false },
  { feature: "Domain connection & launch", build: true, hosting: false },
  { feature: "Secure hosting with SSL", build: false, hosting: true },
  { feature: "Software & security updates", build: false, hosting: true },
  { feature: "Backups & uptime monitoring", build: false, hosting: true },
  { feature: "Small content edits on request", build: false, hosting: true },
  { feature: "Client dashboard access", build: true, hosting: true },
];

/** Add-ons — prices intentionally not listed until confirmed by the studio. */
export const ADDONS = [
  { name: "Extra pages", note: "Additional pages beyond your agreed scope." },
  { name: "Local SEO", note: "Ongoing local search optimization." },
  { name: "Google Business Profile setup", note: "Claim, verify and complete your listing." },
  { name: "Copywriting & content", note: "Professionally written page copy." },
  { name: "E-commerce setup", note: "Product catalog, cart and checkout." },
  { name: "Integrations & automations", note: "Booking, CRM, email and payment tools." },
];
